module.exports = __webpack_public_path__ + "static/mr-concert-performance-20-835f19e27c09a31b0a2f44560d1b2061.jpg";